import React from 'react'
import { Icon } from '@evertel/web/ui'

import { DragData } from './types'
import { LAYOUT_TYPE_LABELS, ELEMENT_TYPE_LABELS, TYPE_ICONS } from './constants'

interface DragOverlayContentProps {
    dragData: DragData
}

/**
 * Content displayed in the drag overlay while dragging items.
 * Shows an icon and label for the item being dragged.
 */
export const DragOverlayContent: React.FC<DragOverlayContentProps> = ({
    dragData
}) => {
    const getLabel = (): string => {
        if (dragData.type === 'layout' && dragData.layoutType) {
            return LAYOUT_TYPE_LABELS[dragData.layoutType] || dragData.layoutType
        }
        if (dragData.type === 'element' && dragData.elementType) {
            return ELEMENT_TYPE_LABELS[dragData.elementType] || dragData.elementType
        }
        return 'Item'
    }

    const getIcon = () => {
        let iconName = 'cube' // default fallback

        if (dragData.type === 'layout' && dragData.layoutType) {
            iconName = TYPE_ICONS[dragData.layoutType] || 'cube'
        } else if (dragData.type === 'element' && dragData.elementType) {
            iconName = TYPE_ICONS[dragData.elementType] || 'cube'
        }

        return (
            <Icon
                name={iconName as any}
                fixedWidth
                className="me-2"
            />
        )
    }

    return (
        <div className="sb-drag-overlay">
            {getIcon()}
            <span>{getLabel()}</span>
        </div>
    )
}
